import '../../assets/index20.css';var K = Object.defineProperty, L = Object.defineProperties;
var U = Object.getOwnPropertyDescriptors;
var p = Object.getOwnPropertySymbols;
var z = Object.prototype.hasOwnProperty, G = Object.prototype.propertyIsEnumerable;
var W = (a, r, t) => r in a ? K(a, r, { enumerable: !0, configurable: !0, writable: !0, value: t }) : a[r] = t, g = (a, r) => {
  for (var t in r || (r = {}))
    z.call(r, t) && W(a, t, r[t]);
  if (p)
    for (var t of p(r))
      G.call(r, t) && W(a, t, r[t]);
  return a;
}, T = (a, r) => L(a, U(r));
var Q = (a, r) => {
  var t = {};
  for (var n in a)
    z.call(a, n) && r.indexOf(n) < 0 && (t[n] = a[n]);
  if (a != null && p)
    for (var n of p(a))
      r.indexOf(n) < 0 && G.call(a, n) && (t[n] = a[n]);
  return t;
};
import { jsxs as d, jsx as e, Fragment as M } from "react/jsx-runtime";
import { Button as c } from "../Button/index.js";
import { Title as X } from "../Title/index.js";
import { PaperPlaneTopFarFAIcon as A, TriangleExclamationFarFAIcon as V, TrashFarFAIcon as ee, XMarkFarFAIcon as ae } from "../Icons/index.js";
import { forwardRef as re, useEffect as te } from "react";
import { T as b } from "../../Transition-esp-rpzm.js";
import { P as ne } from "../../Portal-CZ-iZqfA.js";
import { S as j } from "../../Stack-CTaaXTID.js";
const le = "Modal-module__wrapper___rdgyn", oe = "Modal-module__overlay___9MGnZ", de = "Modal-module__modal___ET0NO", ie = "Modal-module__header___icaSI", ce = "Modal-module__title___NGy-S", se = "Modal-module__closeButton___lXGNX", _e = "Modal-module__contentWrapper___yTMd3", me = "Modal-module__footer___yQ3IF", ve = "Modal-module__variantContainer___MC0Id", he = "Modal-module__variantTitle___Oh8TJ", ue = "Modal-module__variantMessage___6-Dwd", fe = "Modal-module__variantActions___0s9QG", pe = "Modal-module__variantIcon___Qqtla", o = {
  wrapper: le,
  overlay: oe,
  modal: de,
  header: ie,
  title: ce,
  closeButton: se,
  contentWrapper: _e,
  footer: me,
  variantContainer: ve,
  variantTitle: he,
  variantMessage: ue,
  variantActions: fe,
  variantIcon: pe
}, ge = re((Me, Z) => {
  var E = Me, {
    centered: a = !0,
    children: r,
    className: t,
    classNames: n = {},
    onClose: m,
    opened: _,
    position: O = "center",
    size: P = "360px",
    title: v,
    actions: C = [],
    variant: s = "default",
    message: F,
    primaryActionLabel: k,
    secondaryActionLabel: $,
    onPrimaryAction: y,
    onSecondaryAction: w,
    transition: S = "slide-up",
    transitionDuration: I = 200,
    transitionTimingFunction: x = "ease",
    confirmationIcon: q = /* @__PURE__ */ e(A, { size: 16 }),
    warningIcon: D = /* @__PURE__ */ e(V, { size: 16 }),
    dangerIcon: J = /* @__PURE__ */ e(ee, { size: 16 }),
    primaryActionVariant: h = "accent",
    secondaryActionVariant: N = "tertiary",
    withinPortal: R = !0
  } = E, Y = Q(E, [
    "centered",
    "children",
    "className",
    "classNames",
    "onClose",
    "opened",
    "position",
    "size",
    "title",
    "actions",
    "variant",
    "message",
    "primaryActionLabel",
    "secondaryActionLabel",
    "onPrimaryAction",
    "onSecondaryAction",
    "transition",
    "transitionDuration",
    "transitionTimingFunction",
    "confirmationIcon",
    "warningIcon",
    "dangerIcon",
    "primaryActionVariant",
    "secondaryActionVariant",
    "withinPortal"
  ]);
  te(() => {
    const i = (u) => {
      u.key === "Escape" && _ && m();
    };
    return _ && (document.body.style.overflow = "hidden", document.addEventListener("keydown", i)), () => {
      document.body.style.overflow = "unset", document.removeEventListener("keydown", i);
    };
  }, [_, m]);
  const H = () => {
    if (s === "default") {
      const i = C.filter((l) => l.position === "left"), u = C.filter((l) => l.position !== "left");
      return /* @__PURE__ */ d(M, { children: [
        v && /* @__PURE__ */ d("div", { className: `${o.header} ${n.header || ""}`, children: [
          /* @__PURE__ */ e(X, { order: 4, className: o.title, children: v }),
          /* @__PURE__ */ e(
            c,
            {
              className: o.closeButton,
              onClick: m,
              variant: "tertiary",
              size: "lg",
              children: /* @__PURE__ */ e(ae, {})
            }
          )
        ] }),
        /* @__PURE__ */ e("div", { className: `${o.contentWrapper} ${n.body || ""}`, children: r }),
        C.length > 0 && /* @__PURE__ */ d("div", { className: `${o.footer} ${n.footer || ""}`, children: [
          i.map((l, f) => /* @__PURE__ */ e(
            c,
            {
              variant: l.variant || "tertiary",
              onClick: l.onClick,
              danger: l.danger,
              style: { marginLeft: "-0.5rem" },
              "data-plum-id": l["data-plum-id"],
              children: l.label
            },
            `left-${f}`
          )),
          /* @__PURE__ */ e("div", { style: { flex: 1 } }),
          u.map((l, f) => /* @__PURE__ */ e(
            c,
            {
              variant: l.variant || (f === u.length - 1 ? "accent" : "secondary"),
              onClick: l.onClick,
              danger: l.danger,
              "data-plum-id": l["data-plum-id"],
              children: l.label
            },
            `right-${f}`
          ))
        ] })
      ] });
    }
    return /* @__PURE__ */ d("div", { className: `${o.variantContainer} ${n.body || ""}`, children: [
      /* @__PURE__ */ d(j, { className: o.variantIcon, "data-variant": s, children: [
        s === "confirmation" && q,
        s === "warning" && D,
        s === "danger" && J
      ] }),
      /* @__PURE__ */ d(j, { gap: "xxs", children: [
        v && /* @__PURE__ */ e(X, { order: 4, className: o.variantTitle, children: v }),
        F && /* @__PURE__ */ e("p", { className: o.variantMessage, children: F })
      ] }),
      /* @__PURE__ */ d("div", { className: o.variantActions, children: [
        s === "confirmation" && /* @__PURE__ */ d(M, { children: [
          /* @__PURE__ */ e(c, { variant: N, onClick: w, children: $ || "Edit" }),
          /* @__PURE__ */ e(c, { variant: h, onClick: y, children: k })
        ] }),
        s === "warning" && /* @__PURE__ */ d(M, { children: [
          /* @__PURE__ */ e(c, { variant: N, onClick: w, children: $ || "Cancel" }),
          /* @__PURE__ */ e(c, { variant: h, onClick: y, children: k || "Leave" })
        ] }),
        s === "danger" && /* @__PURE__ */ d(M, { children: [
          /* @__PURE__ */ e(c, { variant: N, onClick: w, children: $ || "Cancel" }),
          /* @__PURE__ */ e(c, { danger: h === "primary", variant: h, onClick: y, children: k || "Delete" })
        ] })
      ] })
    ] });
  }, B = /* @__PURE__ */ d("div", { className: `${o.wrapper} ${n.wrapper || ""}`, children: [
    /* @__PURE__ */ e(
      b,
      {
        mounted: _,
        transition: "fade",
        duration: I,
        timingFunction: x,
        children: (i) => /* @__PURE__ */ e("div", { className: `${o.overlay} ${n.overlay || ""}`, onClick: m, style: i })
      }
    ),
    /* @__PURE__ */ e(
      b,
      {
        mounted: _,
        transition: S,
        duration: I,
        timingFunction: x,
        children: (i) => /* @__PURE__ */ e(
          "div",
          T(g({
            className: `${o.modal} ${t || ""}`,
            style: g(T(g({}, i), {
              maxWidth: P
            }), O === "center" && a ? {
              top: "50%",
              transform: `${i.transform || ""} translateY(-50%)`
            } : {}),
            ref: Z
          }, Y), {
            children: H()
          })
        )
      }
    )
  ] });
  return R ? /* @__PURE__ */ e(ne, { children: B }) : B;
});
ge.displayName = "Modal";
export {
  ge as Modal
};
